<span class="error-message">
	<ng-content></ng-content>
</span>
